import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import {
  Box,
  Paper,
  Typography,
  Button,
  Container,
  Alert
} from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';

const SetupRequired: React.FC = () => {
  const { user, logout } = useAuth0();

  const handleLogout = () => {
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Paper sx={{ p: 4, width: '100%' }}>
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <SettingsIcon sx={{ fontSize: 64, color: 'warning.main', mb: 2 }} />
            <Typography variant="h5" component="h1" gutterBottom>
              Setup Required
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
              Your account has system access but hasn't been set up yet.
            </Typography>
          </Box>

          <Alert severity="info" sx={{ mb: 3 }}>
            <Typography variant="body2">
              <strong>Logged in as:</strong> {user?.email}
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              You have been granted access to the Advisor Dashboard, but your account permissions need to be configured by an administrator.
            </Typography>
          </Alert>

          <Box sx={{ mb: 3 }}>
            <Typography variant="body2" color="text.secondary">
              <strong>What's next?</strong>
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              1. Contact your dashboard administrator<br/>
              2. Ask them to add your account in <strong>Dashboard → Users</strong><br/>
              3. They'll assign you a role and customer access<br/>
              4. Log out and log back in to activate your permissions
            </Typography>
          </Box>

          <Alert severity="warning" sx={{ mb: 3 }}>
            <Typography variant="caption">
              <strong>For administrators:</strong> Go to Dashboard → Users → Add User to configure this account with the appropriate role (superadmin, dashboard-admin, or dashboard-advisor) and assigned customer IDs.
            </Typography>
          </Alert>

          <Box sx={{ textAlign: 'center' }}>
            <Button
              fullWidth
              variant="contained"
              onClick={handleLogout}
              startIcon={<LogoutIcon />}
            >
              Sign Out
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default SetupRequired;
